<template>
  <v-card elevation="0">
    <v-card-text class="px-0" v-if="showText">
      {{ $t("components.thg.thgDialogYearSelection.subtitle", { numberplate: numberplate }) }}
    </v-card-text>
    <v-card-text class="px-0">
      <v-radio-group v-model="years">
        <v-sheet
          outlined
          rounded
          :color="activeCardStyle(products.years)"
          v-for="(products, i) in activeProducts"
          :key="i"
          class="mb-2 py-n6"
        >
          <v-card flat @click="years = products.years">
            <thg-products-price-combo-card :showPrice="true" v-if="products.prices.length > 1" :product="products" />
            <thg-products-price-card :showPrice="true" v-else :product="products" />
          </v-card>
        </v-sheet>
      </v-radio-group>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { ThgCreateModule } from "@/store/modules/thg.create.store";
import { Component, Prop, Vue } from "vue-property-decorator";
import { PartnerActiveOfferModule } from "@/store/modules/partner-active-config.store";
import { ThgVehicleTypes } from "@/store/enum/thg/thg-vehicle-types.enum";
import ThgProductsPriceCard from "@/views/thg/ThgProductsPriceCard.vue";
import { ActivePrice } from "@/store/models/thg/active-price";
import ThgProductsPriceComboCard from "@/views/thg/ThgProductsPriceComboCard.vue";

@Component({
  components: { ThgProductsPriceCard, ThgProductsPriceComboCard }
})
export default class ThgDialogYearSelection extends Vue {
  @Prop()
  possibleYears!: number[];

  @Prop()
  numberplate!: string;

  @Prop({ default: true })
  showText!: boolean;

  activeCardStyle(years: number[]) {
    if (JSON.stringify(this.years) === JSON.stringify(years)) {
      return "primary";
    }
    return "";
  }

  get years() {
    return ThgCreateModule.years;
  }

  set years(years: number[]) {
    ThgCreateModule.setYears(years);
  }

  get activeProducts() {
    const price = new ActivePrice(
      PartnerActiveOfferModule.prices.filter((item) => this.possibleYears.includes(item.year))
    );

    return price.getYearCombinationsByVehicleClass(ThgVehicleTypes.M1);
  }

  get selectedYears() {
    return ThgCreateModule.years;
  }

  set selectedYears(years: number[]) {
    ThgCreateModule.setYears(years);
  }
}
</script>
